import React from 'react';
import TopBar from './TopBar';
import './FAQPage.css';
import { useToast } from '../context/ToastContext';

// FAQ Item Component
function FAQItem({ question, answer }) {
  return (
    <div className="faq-item">
      <h3 className="faq-question">{question}</h3>
      <p className="faq-answer">{answer}</p>
    </div>
  );
}

// FAQ Page Component
export default function FAQPage() {
  const email = 'CondoEats050126@gmail.com';
  const { showSuccess } = useToast();

  const handleEmailAction = async () => {
    // Try to copy to clipboard
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(email);
        showSuccess('Email address copied to clipboard');
      }
    } catch (err) {
      // Silently fail - not critical since mailto will still work
      console.error('Failed to copy:', err);
    }
    
    // Always open mail client (regardless of copy success/failure)
    window.location.href = `mailto:${email}`;
  };

  const faqs = [
    {
      question: "What is CondoEats?",
      answer: "CondoEats is a community-based marketplace that connects residents who prepare home-cooked food with residents who wish to purchase food within the same residential community."
    },
    {
      question: "Which condos are participating in CondoEats?",
      answer: "Currently only Monash Waterfront Residence is available. We're planning to expand to other condos in the Sunway area soon, so please stay tuned!"
    },
    {
      question: "Who can sell on CondoEats?",
      answer: "Residents who enjoy cooking, have extra home-prepared food, or have unopened and unexpired dry food, and wish to earn side income by sharing food within their residential community."
    },
    {
      question: "Who can buy from CondoEats?",
      answer: "Residents who are looking for fresh, affordable home-cooked meals or dry food, with the convenience of purchasing and picking up food within their own residential community."
    },
    {
      question: "Does CondoEats prepare, inspect, or deliver food?",
      answer: "No. CondoEats does not prepare, inspect, store, or deliver food. Food handover occurs directly between Buyers and Sellers."
    },
    {
      question: "How does food delivery work?",
      answer: "There's no delivery. After placing an order, the buyer picks up the food at a designated spot in their residential area (e.g., the lobby \"grab food\" area). The exact pickup location will be stated when the order is placed."
    },
    {
      question: "Is the food commercially certified?",
      answer: "No. All food listed on CondoEats is prepared in home kitchens and is not commercially certified."
    },
    {
      question: "What should I do if I have food allergies or dietary restrictions?",
      answer: "Buyers are responsible for reviewing ingredient and allergen information before placing an order."
    },
    {
      question: "When should the food be consumed?",
      answer: "Food should be consumed on the same day of pickup, unless the item is dry food."
    },
    {
      question: "Can I cancel my order or request a refund?",
      answer: "Order cannot be cancelled or refunded once the payment has been done. Refunds can only be requested via email if and only if the food is not delivered at the agreed pickup time."
    },
    {
      question: "What happens if I miss my pickup time?",
      answer: "Buyers can collect their food at any time after the agreed pick up time. Missed pickup results in NO REFUND."
    },
    {
      question: "What if there is an issue with my order?",
      answer: "Buyers may leave a review after the pickup time has passed, or contact CondoEats via email."
    },
    {
      question: "Can a Seller account be suspended?",
      answer: "Yes. Accounts may be suspended or removed for repeated violations or safety concerns."
    },
    {
      question: "Who do I contact if I have questions or concerns?",
      answer: `You may contact CondoEats at: Email: ${email}`
    }
  ];

  return (
    <div className="faq-page">
      <TopBar />
      <main className="faq-main">
        <div className="faq-container">
          <h1 className="faq-title">FAQs</h1>
          
          <div className="faq-content">
            {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
            ))}
            
            <div className="faq-contact-section">
              <p className="faq-contact-text">
                Still have questions? Contact us at:
              </p>
              <div className="faq-contact-email">
                <button
                  type="button"
                  className="email-action-btn"
                  onClick={handleEmailAction}
                  aria-label="Email Condo Eats"
                  title="Opens your mail client and copies the email address"
                >
                  {email}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}